module.exports = __webpack_public_path__ + "static/media/rbi_ogo_nbfc12.077d2c77.svg";